import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { DashboardMetricTileGrid } from '@components/pages/Dashboard/Shared/DashboardMetricTileGrid.component'
import type { DashboardMetricItemData } from '@utils/dashboardMetrics.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'

type ClinicalEfficiencyCardProps = {
  titleHref: string
  metrics: DashboardMetricItemData[]
  loading: boolean
  /** Clinical efficiency response has arrived (`data != null`). */
  hasPayload: boolean
  /** Displayed KPIs (avg. time, provider utilization, tx opportunities) are nonzero. */
  hasData: boolean
}

export function ClinicalEfficiencyCard({
  titleHref,
  metrics: clinicalEfficiencyMetrics,
  loading: clinicalEfficiencyLoading,
  hasPayload,
  hasData: clinicalEfficiencyHasData,
}: ClinicalEfficiencyCardProps): React.ReactElement {
  const isEmpty = shouldShowDashboardSectionEmpty(
    clinicalEfficiencyLoading,
    clinicalEfficiencyHasData,
  )
  const pending = isDashboardSectionPending(
    clinicalEfficiencyLoading,
    hasPayload,
  )

  return (
    <DashboardSectionCard
      title="Clinical efficiency"
      titleHref={titleHref}
      className="dashboard-performance-full-width"
      loading={pending}
      skeleton={{ metrics: 3, metricColumns: 3, block: 'none' }}
      isEmpty={isEmpty}
    >
      <div className="dashboard-performance-clinical-metrics">
        <DashboardMetricTileGrid
          metrics={clinicalEfficiencyMetrics}
          columns={3}
        />
      </div>
    </DashboardSectionCard>
  )
}
